export const IntentionShareCard = ({ result, intentionId }) => (
  <article className="intention-share-card" data-testid="intention-share-card">
    <header><img src="/brand/humn-wordmark.png" alt="HUMN" /><span>THE AI SOCIAL NETWORK</span></header>
    <p>MY INTENTION</p>
    <h3>{result.share_lines.map((line) => <span key={line}>{line}</span>)}</h3>
    <div>{result.tags.map((tag) => <strong key={tag}>#{tag.replace(/\s+/g, "")}</strong>)}</div>
    <footer><span>INTENTION ID<br /><b>{intentionId}</b></span><em>Make your life happen.</em></footer>
  </article>
);

const wrapText = (context, text, maxWidth) => {
  const words = text.split(" ");
  const lines = [];
  let line = "";
  words.forEach((word) => {
    const candidate = `${line} ${word}`.trim();
    if (context.measureText(candidate).width > maxWidth && line) { lines.push(line); line = word; }
    else line = candidate;
  });
  if (line) lines.push(line);
  return lines;
};

export const downloadIntentionCard = (result, intentionId) => {
  const canvas = document.createElement("canvas");
  canvas.width = 1080; canvas.height = 1350;
  const context = canvas.getContext("2d");
  const gradient = context.createLinearGradient(0, 0, 1080, 1350);
  gradient.addColorStop(0, "#08080a"); gradient.addColorStop(.6, "#17101b"); gradient.addColorStop(1, "#351126");
  context.fillStyle = gradient; context.fillRect(0, 0, 1080, 1350);
  context.fillStyle = "#ff2a85"; context.beginPath(); context.arc(900, 120, 240, 0, Math.PI * 2); context.globalAlpha = .18; context.fill(); context.globalAlpha = 1;
  context.fillStyle = "#ffffff"; context.font = "700 48px Arial"; context.fillText("HUMN", 82, 110);
  context.fillStyle = "#ff72ad"; context.font = "600 22px Arial"; context.fillText("MY INTENTION", 82, 240);
  context.fillStyle = "#ffffff"; context.font = "500 52px Arial";
  const lines = wrapText(context, result.core_intention, 900);
  lines.slice(0, 7).forEach((line, index) => context.fillText(line, 82, 335 + index * 68));
  context.fillStyle = "#d0c6d3"; context.font = "500 25px Arial"; context.fillText(result.tags.map((tag) => `#${tag.replace(/\s+/g, "")}`).join("  "), 82, 940);
  context.strokeStyle = "rgba(255,255,255,.2)"; context.beginPath(); context.moveTo(82, 1040); context.lineTo(998, 1040); context.stroke();
  context.fillStyle = "#938a96"; context.font = "500 19px Arial"; context.fillText("INTENTION ID", 82, 1110); context.fillText("Make your life happen.", 700, 1110);
  context.fillStyle = "#ffffff"; context.font = "600 24px Arial"; context.fillText(intentionId, 82, 1150);
  const link = document.createElement("a"); link.download = `${intentionId}.png`; link.href = canvas.toDataURL("image/png"); link.click();
};